module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"areu18":"Are you 18+ years old?","warning":"","yes_button":"YES, I am","no_button":"NO, I am not"},"ja":{"areu18":"あなたは18歳以上ですか？","warning":"","yes_button":"はい (入場する)","no_button":"いいえ"}}')
  delete Component.options._Ctor
}
